import { createStore, ObservableMap } from "@stencil/store";
import { getMachineList, ProductType } from "../../api/machine";
import { getSoftwares, getSoftwareTypes, Software, SoftwareType } from "../../api/software";
import { getNotificationTypes, NotificationType } from "../../api/notificationType";
import { ApiClient } from "../../utils/ApiClient";

export interface ApiStoreState {
    machinesLoading: boolean;
    machines: ProductType[];
    softwaresLoading: boolean;
    softwares: Software[];
    softwareTypes: SoftwareType[];
    notificationTypesLoading: boolean;
    notificationTypes: NotificationType[];
    loading: boolean;
}
export type ApiStore = ObservableMap<ApiStoreState>;

export const createApiStore = () => {
    const store = createStore<ApiStoreState>({
        machinesLoading: true,
        machines: [],
        softwaresLoading: true,
        softwares: [],
        softwareTypes: [],
        notificationTypesLoading: true,
        notificationTypes: [],
        loading: true
    });
    store.onChange("machinesLoading", () => updateLoading());
    store.onChange("softwaresLoading", () => updateLoading());
    store.onChange("notificationTypesLoading", () => updateLoading());

    function updateLoading() {
        store.state.loading = store.state.machinesLoading || store.state.softwaresLoading || store.state.notificationTypesLoading;
    }

    return store;
};

export const loadFormDataFromApi = async (apiStore: ApiStore, apiClient: ApiClient) => {
    apiStore.state.machinesLoading = true;
    apiStore.state.softwaresLoading = true;
    apiStore.state.notificationTypesLoading = true;

    getMachineList(apiClient).then((machines) => {
        apiStore.state.machines = machines;
        apiStore.state.machinesLoading = false;
    });
    getSoftwares(apiClient).then((softwares) => {
        apiStore.state.softwares = softwares;
        apiStore.state.softwareTypes = getSoftwareTypes(softwares);
        apiStore.state.softwaresLoading = false;
    });
    getNotificationTypes(apiClient).then((notificationTypes) => {
        apiStore.state.notificationTypes = notificationTypes;
        apiStore.state.notificationTypesLoading = false;
    });
};
